// data from virtual API
export const data = [
  {
    title: 'Very Short Text',
    important: true,
    like: false,
    id: 1,
  },
  {
    title: 'Very Medium Title Record Text',
    important: false,
    like: true,
    id: 2,
  },
  {
    title: 'Very very Long long Text Title Record',
    important: false,
    like: false,
    id: 3,
  },
];
